<script>
import { get } from 'lodash';
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data() {
    return {};
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getSpecificFieldValue(fieldName) {
      if (Fandom.isUserRegistered()) {
        const user = get(this.pageModel, ['user'], {});
        if (user.newsletter) {
          return get(this.content, ['complete', fieldName], undefined);
        } else {
          return get(this.content, ['newsletter_missing', fieldName], undefined);
        }
      } else {
        return get(this.content, ['anonymous', fieldName], undefined);
      }
    }
  },
  computed: {
    aspectRatioClasses() {
      return [
        (Fandom.exists(this.content.height) && this.content.height.indexOf("$") === 0) ? this.content.height.replace("$", "ar-") : "ar-16by9",
      ];
    },
    contentClasses() {
      const classes = [];

      if (this.content.boxed) {
        classes.push("inset");
      }

      classes.push(this.content.theme ? `${this.content.theme}-theme` : "");

      // Height management. Default 100vh.
      if (!Fandom.exists(this.content.height)) {
        classes.push("mh-100vh-header-sm");
      }

      // Mobile reverse management. Default image and text
      if (globalState.viewport.sm && this.content.reverse_mobile) {
        classes.push("flex-column-reverse");
      } else if (this.content.reverse) {
        classes.push("flex-row-reverse");
      }

      return classes;
    },
    contentStyle() {
      let style = { };
      if (globalState.viewport.md || globalState.viewport.lg || globalState.viewport.xl) {
        style["min-height"] = (Fandom.exists(this.content.height) && this.content.height.indexOf("$") !== 0) ? this.content.height : null;
      }
      if (!this.content.theme) {
        style["background-color"] = this.content.background_color ? this.content.background_color : "inherit";
        style["color"] = this.content.text_color ? this.content.text_color : "inherit";
      }
      return style;
    },
    mediaColumnClasses() {
      const classes = [];

      // d-md-block preserve image column from md breakpoint.
      if (!Fandom.exists(this.content.image)) {
        classes.push("d-none d-lg-flex")
      } else {
        classes.push("d-flex");
      }

      if (Fandom.exists(this.content.text_column_width)) {
        classes.push("col-lg-" + (12 - parseInt(this.content.text_column_width)));
      } else {
        classes.push("col-lg-6");
      }

      return classes;
    },
    textColumnClasses() {
      const classes = [];
      classes.push(Fandom.exists(this.content.text_column_width) ? "col-lg-" + this.content.text_column_width : "col-lg-6");
      return classes;
    },
    title() {
      return this.getSpecificFieldValue('title');
    },
    titleComposed() {
      return this.getSpecificFieldValue('title_composed');
    },
    description() {
      return this.getSpecificFieldValue('description');
    },
    button() {
      return this.getSpecificFieldValue('button');
    }
  },
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="position-relative" :style="{'background-color': content.outer_background_color && content.background_color}" :class="[contentType]" v-if="isContentVisibleToUser()" two-col-component stripe-newsletter-banner-component>
    <div class="container position-relative overflow-hidden">
      <div
        class="row m-0 w-100 h-100 position-absolute-center bg-cover-center inview_animate_zoom"
        v-if="content.background_image && !content.propagate_background"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
      ></div>
      <div class="position-absolute-center w-100 h-100 layer" v-if="content.background_image"></div>
      <div class="row google-seo-height" :class="contentClasses" :style="contentStyle">
        <div class="col-12 p-0 media-column" :class="mediaColumnClasses">
          <div class="bg-cover-center w-100 position-relative" v-if="content.image" :title="content.image.alt" :style="{'background-image': getBackgroundUrl(content.image.url)}" :class="aspectRatioClasses">
          </div>
        </div>
        <div class="col-12 d-flex flex-column justify-content-center py-4 text-column" :class="textColumnClasses">
          <div class="row justify-content-center">
            <div class="col-sm-10 px-4">
              <div stripe-header v-if="titleComposed">
                <div class="row">
                  <div class="col-12">
                    <component class="title-composed" :is="content.title_tag || 'h2'">
                      <span v-for="title in titleComposed" :class="getTitleStyle(title)" :key="title.$id">
                        {{title.title}}
                      </span>
                    </component>
                  </div>
                </div>
              </div>
              <div class="mt-3" v-if="description" v-html="description"></div>
              <a class="btn btn-light px-5" :href="button.url" :target="getTarget(button)" v-if="button">{{button.title}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

</style>
